module.exports = __webpack_public_path__ + "images/icon/icn_pin_fill_16_primary-e49c7c00.svg";